"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilingModule = void 0;
const base_1 = require("./base");
const fanApp_1 = require("../fanApp");
class ProfilingModule extends base_1.SurveyModule {
    constructor({ index, force, ...rest }) {
        super(rest);
        this._type = "profiling";
        this._index = index;
        this._force = force;
    }
    get index() {
        return this._index;
    }
    set index(index) {
        if (index < 0) {
            throw new Error("index must be greater than or equal to 0");
        }
        this.index = index;
    }
    get force() {
        return this._force;
    }
    set force(force) {
        if (!!force && !fanApp_1.DEFAULT_PROFILING_CATEGORIES.includes(force)) {
            throw new Error(`${force} is not a valid profile category`);
        }
        this.force = force;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const baseModule = {
                index: this.index,
                type: this.type,
            };
            if (this.force) {
                baseModule.force = this.force;
            }
            return baseModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        return this.toBuilderConfig();
    }
    editProps() {
        return undefined;
    }
}
exports.ProfilingModule = ProfilingModule;
//# sourceMappingURL=Profiling.js.map